import HeaderBar from "../Components/HeaderBar";
import Footer from "../Components/Footer";
import DystarYvirlit from "../Components/DystarYvirlit";
import PointsTable from "../Components/PointsTable";
import FullScreenLoader from "../Components/FullScreenLoader";
import { useParams, useSearchParams } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import Kolofon from "../Components/Kolofon";

export default function DystirOgStigatalva() {
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const [scheduleData, setScheduleData] = useState([]);
  const [groupName, setGroupName] = useState("");
  const [cupStatus, setCupStatus] = useState(true);

  // ---------- LOADING: pending counter (fixes stuck spinner) ----------
  const [pending, setPending] = useState(0);
  const loading = pending > 0;

  // Stable setter: increment on true, decrement on false
  const setLoadingState = useCallback((isLoading) => {
    setPending((p) => (isLoading ? p + 1 : Math.max(0, p - 1)));
  }, []);
  // --------------------------------------------------------------------

  const currentTab = searchParams.get("tab") || "dystir";

  useEffect(() => {
    let ended = false;                    // did we already stop the loader?
    const controller = new AbortController();

    const fetchData = async () => {
      try {
        setLoadingState(true);            // START
        const response = await fetch(
          `https://us-central1-hsf-production-505a6.cloudfunctions.net/webApi/groups/${params.kappingId}/schedule`,
          { signal: controller.signal }
        );
        const jsonData = await response.json();
        setScheduleData(jsonData.schedule);
        setGroupName(jsonData.group.name);
        setCupStatus(jsonData.group.cup);
      } catch (error) {
        // AbortError is fine in dev StrictMode re-mounts
        if (error?.name !== "AbortError") {
          console.error("Error fetching data:", error);
        }
      } finally {
        ended = true;
        setLoadingState(false);           // STOP (matches START above)
      }
    };

    fetchData();

    // If component unmounts before finally runs, ensure we STOP once
    return () => {
      controller.abort();
      if (!ended) {
        setLoadingState(false);           // safety STOP to avoid stuck spinner
      }
    };
  }, [params.kappingId, currentTab, setLoadingState]); // include setLoadingState (stable)

  const handleTabChange = (tab) => {
    setSearchParams({ tab });
  };

  return (
    <>
      <HeaderBar kappingSlag={params.kappingSlag} showBack={true} groupName={groupName} />

      <section className="matchesStanding-select">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <ul>
                <li
                  className={currentTab === "dystir" ? "tabselect active" : "tabselect"}
                  onClick={() => handleTabChange("dystir")}
                >
                  Dystir
                </li>
                {!cupStatus && (
                  <li
                    className={currentTab === "stodan" ? "tabselect active" : "tabselect"}
                    onClick={() => handleTabChange("stodan")}
                  >
                    Støðan
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {currentTab === "dystir" && (
        <DystarYvirlit scheduleData={scheduleData} groupName={groupName} />
      )}

      {currentTab === "stodan" && (
        <PointsTable setLoadingState={setLoadingState} competitionId={params.kappingId} />
      )}

      <Footer />
      <Kolofon />

      {loading && <FullScreenLoader />}
    </>
  );
}
